import { User } from 'firebase/auth';
import { IObservableValue } from 'mobx';
import { createContext, useContext } from 'react';
import { IService } from 'services/IService';
import { AuthUser } from '../../models/User';

export type IAuthService = {
  user: IObservableValue<AuthUser | null>;
  userToken: IObservableValue<string | undefined>;
  get isNewUser(): boolean;
  getCurrentUser(): Promise<AuthUser | null>;
  signInWithGoogle(): Promise<User>;
  signInWithApple(): Promise<User>;
  signInWithMail(email: string, password: string): Promise<User>;
  signUpWithMail(email: string, password: string): Promise<User>;
  signInAnonymously(): Promise<User>;
  signOut(): Promise<void>;
  isAuthenticated(): Promise<boolean>;
  sendPasswordResetEmail(email: string): Promise<void>;
  sendEmailVerification(): Promise<void>;
} & IService;

const AuthServiceContext = createContext<null | IAuthService>(null);

export const AuthProvider = AuthServiceContext.Provider;
export function useAuthService() {
  const auth = useContext(AuthServiceContext);
  if (auth === null) {
    throw new Error(
      'AuthService cannot be null, please add a context provider'
    );
  }
  return auth;
}
